// src/pages/PrivacyPage.jsx
import React from "react";
import {FooterSection} from "../components/Footer.jsx";
import {Link} from "react-router-dom";
import {Menu, X} from "lucide-react";

const PrivacyPage = () => {
    return (
        <div className="min-h-screen bg-zinc-900 text-gray-100">
            {/* NavBar */}
            <nav className="sticky top-0 z-50 bg-[#1a1a1a] border-b border-[#FF4D00]/10 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo */}
                        <Link to="/" className="flex items-center space-x-3">
                            <div className="w-8 h-8">
                                <img
                                    src={require("../assets/helga_launcher_icon.png")}
                                    alt="Helga Logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span
                                className="text-2xl font-bold bg-clip-text text-[#FF4D00]">
                                Helga Festival Companion
                             </span>
                        </Link>
                    </div>
                </div>
            </nav>


            {/* Main Content */}
            <main className="py-12">
                <div className="max-w-4xl mx-auto px-4">
                    <div className="prose prose-invert max-w-none">
                        <div className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-[#FF4D00]/10">
                            <h2 className="text-2xl font-semibold mb-6 text-[#FF4D00]">
                                Privacy

                            </h2>

                            <h3 className="text-xl font-semibold mt-8 mb-4">Privacy Policy</h3>
                            <p className="text-gray-300 mb-4">Below, we would like to inform you about our privacy
                                policy. This provides information about the collection and use of personal data when
                                using our website. We comply with the applicable data protection laws in Germany. You
                                can access this statement at any time on our website. Please note that data transmission
                                over the internet (e.g., communication via email) may have security gaps and cannot be
                                fully protected from access by third parties. The use of the contact details in our
                                legal notice for commercial advertising purposes is expressly not desired, unless we
                                have previously given our written consent or there is already a business relationship.
                                The provider and all individuals named on this website expressly object to any
                                commercial use and transfer of their data.

                            </p>
                            <h3 className="text-xl font-semibold mt-8 mb-4">Personal Data</h3>
                            <p className="text-gray-300 mb-4">You can visit our website without providing any personal
                                data. If personal data (such as name, address, or email address) is collected on our
                                pages, this is done, where possible, on a voluntary basis. These data will not be passed
                                on to third parties without your express consent. If a contractual relationship is to be
                                established, designed, or modified between you and us, or if you make an inquiry to us,
                                we collect and use personal data to the extent necessary for these purposes (inventory
                                data). We collect, process, and use personal data to the extent necessary to enable you
                                to use our online services (usage data). All personal data is stored only as long as
                                necessary for the mentioned purpose (processing your inquiry or fulfilling a contract).
                                Statutory retention periods for tax and commercial law are taken into account. Upon
                                request from the competent authorities, we may provide information about this data
                                (inventory data) if this is necessary for the purposes of criminal prosecution, danger
                                prevention, to fulfill the legal tasks of constitutional protection authorities or the
                                Military Counterintelligence Service, or for the enforcement of intellectual property
                                rights.</p>
                            <h3 className="text-xl font-semibold mt-8 mb-4">Right to Information</h3>
                            <p className="text-gray-300 mb-4">You have the right to obtain information free of charge
                                and without delay about the personal data we have collected about you. You also have the
                                right to withdraw your consent to the use of your personal data with effect for the
                                future at any time. To request information, please contact the provider using the
                                contact details in the legal notice.</p>
                        </div>
                    </div>
                </div>
            </main>
            <>
                <FooterSection/>
            </>
        </div>
    );
};

export default PrivacyPage;
